// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__x4I9R","toggleWrap":"styles_toggleWrap__2nLVO","content":"styles_content__2MaF1","selectAreaCode":"styles_selectAreaCode__NvB-y"};